module.exports = __webpack_public_path__ + "media/images/down-93d97fa1a71e4a2d25579949b36627a6.png";